module.exports = __webpack_public_path__ + "static/img/GA.bfe9320a.svg";